import { ErrorHandler, Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Logger } from '@app/utils/logger';
import { HeartbeatActions } from '@components/heartbeat/heartbeat.actions';

/**
 * @description Global error handler to catch all unhandled errors.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private readonly router = inject(Router);
  private readonly store = inject(Store);

  private readonly logger = Logger.getInstance('GlobalErrorHandler');

  /**
   * @description Handle global errors.
   * @param {unknown} error The error to handle.
   */
  handleError(error: any): void {
    const page = this.router.url; // Current URL
    const errorMessage = error?.message ?? 'unknown'; // Extract error message

    this.logger.error(`Runtime error at ${page}: ${errorMessage}`, error);

    this.store.dispatch(
      HeartbeatActions.sendMessage({
        message: `Runtime Error ${JSON.stringify({ page, error })}`
      })
    );
  }
}
